<template>
  <div>
    <router-link v-if="$can('change-setting', 'notification')" :to="'/news/update/'+row.id" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
      <i class="fa fa-edit"></i>
    </router-link>
    <router-link :to="'/news/see/'+row.id" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
      <i class="fa fa-eye"></i>
    </router-link>

    <button v-if="$can('change-setting', 'notification')" @click="deleteNews" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
      <i class="fa fa-trash"></i>
    </button>
  </div>
</template>

<script>
import Vue from "vue";

import { newsService } from "@/common/api.service";

export default Vue.extend({
  props: {
    row: {
      required: true,
    },
    index: {
      required: true,
    },
    datatable: {
      required: true,
    },
  },
  methods: {
    deleteNews() {
      newsService
        .deleteNews(this.row.id)
        .then((response) => {
          location.reload();
          // this.showMsg(form, "success", response.data.message);
        })
        .catch(({ response }) => {
          // this.showMsg(form, "danger", response.data.message);
        })
        .finally(() => {});
    },
  },
});
</script>

<style>
</style>